<template>
    <div class="sdk-dimension-container">
        <el-form :model="params" :rules="paramsRules" ref="form" :label-width="labelWidth">
            <el-form-item label="游戏版本：" prop="game_version_id">
                <el-select
                    size="small"
                    v-model="params.game_version_id"
                    placeholder="游戏版本"
                    class="sdkconfigedit-formitem-width"
                    :disabled="selDisable"
                >
                    <el-option
                        v-for="item in gameVersion"
                        :key="item.game_version_id"
                        :label="item.version"
                        :value="item.game_version_id"
                    >
                    </el-option>
                </el-select>
                <el-button
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    :disabled="selDisable"
                    @click="
                        gameVersionDialogFormVisible = true
                    "
                    >新增
                </el-button>
            </el-form-item>
            <el-form-item label="包名："  prop="package_id">
                <el-select
                    size="small"
                    v-model="params.package_id"
                    placeholder="包名"
                    :disabled="selDisable"
                    class="sdkconfigedit-formitem-width"
                    @change="handlerPackage"
                >
                    <el-option
                        v-for="item in packageList"
                        :key="item.package_name"
                        :label="item.package_name"
                        :value="item.package_id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发行渠道：" prop="store_id">
                <el-select
                    size="small"
                    v-model="params.store_id"
                    placeholder="发行渠道"
                    class="sdkconfigedit-formitem-width"
                    :disabled="selDisable"
                >
                    <el-option
                        v-for="item in packageStoreList"
                        :key="item.store_id"
                        :label="item.store_name"
                        :value="item.store_id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="SDK版本：" prop="sdk_version_id">
                <el-select
                    size="small"
                    v-model="params.sdk_version_id"
                    placeholder="SDK版本"
                    class="sdkconfigedit-formitem-width"
                    :disabled="selDisable"
                >
                    <el-option
                        v-for="item in sdkVersion"
                        :key="item.sdk_version_id"
                        :label="item.version"
                        :value="item.sdk_version_id"
                    >
                    </el-option>
                </el-select>
                <span v-if="this.operate_type !== '' && !this.releasePlan.length" class="allow-auto-process">
                    经系统判断，当前版本未配置<a
                        :href="configUrl()"
                        target="_blank"
                    >SDK配置文件</a>！
                </span>
            </el-form-item>
            <el-form-item>
                <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail" :disabled="!this.releasePlan.length">下一步</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            class="el-dialog__body_self"
            title="新增版本"
            :visible.sync="gameVersionDialogFormVisible"
            width="600px"
        >
            <el-form :model="gameVersionForm" labelWidth="80px">
                <el-form-item label="游戏版本">
                    <el-input
                        size="small"
                        v-model="gameVersionForm.game_version"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="gameVersionDialogFormVisible = false"
                    size="mini"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="
                        gameVersionDialogFormVisible = false;
                        gameVersionNew();
                    "
                    size="mini"
                >
                    确 定
                </el-button>
            </div>
        </el-dialog>
<!--        <el-dialog-->
<!--            title="提示"-->
<!--            :visible.sync="isNotConfigVisible"-->
<!--            width="600px"-->
<!--        >-->
<!--            <div>-->
<!--                经系统判断，当前版本未配置<a-->
<!--                    :href="configUrl()"-->
<!--                    target="_blank"-->
<!--                    >SDK配置文件</a>！-->
<!--            </div>-->
<!--            <div slot="footer" class="dialog-footer">-->
<!--                <el-button-->
<!--                    @click="isNotConfigVisible = false"-->
<!--                    size="mini"-->
<!--                    >取 消</el-button-->
<!--                >-->
<!--            </div>-->
<!--        </el-dialog>-->
    </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
export default {
    name: 'search-dimension',
    data() {
        return {
            gameVersionDialogFormVisible: false,
            isNotConfigVisible: false,
            selDisable: false,
            operate_type: '',
            params: {
                package_id: '',
                game_version_id: '',
                store_id: '',
                sdk_version_id: '',
                step: 'query'
            },
            gameVersionForm: {
                game_version: ''
            },
            paramsRules: {
                package_id: [{
                    required: true, message: '请选择包名！'
                }],
                game_version_id: [{
                    required: true, message: '请选择游戏版本！'
                }],
                store_id: [{
                    required: true, message: '请选择发行渠道！'
                }],
                sdk_version_id: [{
                    required: true, message: '请选择SDK版本！'
                }]
            }
        }
    },
    props: ['isDetail', 'isCopy','labelWidth'],
    computed: {
        ...mapState(['$helper','$routerMapsDefined', '$activeGameCode']),
         ...mapState("sdkReleasesEdit", [
            "gameVersion",
            "packageList",
            "packageStoreList",
            "sdkVersion",
            "releasePlan",
            "data"
        ]),
        isDisabled() {
            return this.operate_type==='edit';
        }
    },
    watch: {
        'data.query'(){
            this.params = {
                package_id: parseInt(this.data.query.package_id),
                game_version_id: parseInt(this.data.query.game_version_id),
                store_id: this.data.query.store_id,
                sdk_version_id: parseInt(this.data.query.sdk_version_id),
                step: 'query'
            }
            this.GET_RELEASE_PLAN({
                platform: this.$helper.helper.getParamers("platform"),
                sdk_version_id: this.params.sdk_version_id,
                store_id: this.params.store_id,
                package_id: this.params.package_id,
            });
        },
        params:{
            handler() {
                if(this.params.package_id !== '' && this.params.game_version_id !== '' && this.params.sdk_version_id !== '' && this.params.store_id !== ''){
                    this.GET_RELEASE_PLAN({
                        platform: this.$helper.helper.getParamers("platform"),
                        sdk_version_id: this.params.sdk_version_id,
                        store_id: this.params.store_id,
                        package_id: this.params.package_id,
                    });
                    this.operate_type = 'add'
                    //this.isNotConfigVisible = !this.releasePlan.length
                }
            },deep:true
        }
    },
    methods: {
        ...mapActions("sdkReleasesEdit", [
            "GET_PACKAGE_STORE",
            "GET_RELEASE_PLAN",
            "NEW_GAME_VERSION",
        ]),
        gameVersionNew() {
            this.NEW_GAME_VERSION({
                version: this.gameVersionForm.game_version
            });
            this.gameVersionForm.game_version = "";
        },
        handlerPackage(value) {
            this.GET_PACKAGE_STORE({
                package_id: value,
                platform: this.$helper.helper.getParamers("platform")
            }).then(() => {
                // if (
                //     this.operate_type === "copy" ||
                //     (this.params.sdk_version_id &&
                //         this.params.store_id &&
                //         this.params.package_id)
                // ) {
                //     this.SdkVersionChanged();
                // }
            });
        },
        SdkVersionChanged() {
            // this.GET_RELEASE_PLAN({
            //     platform: this.$helper.helper.getParamers("platform"),
            //     sdk_version_id: this.params.sdk_version_id,
            //     store_id: this.params.store_id,
            //     package_id: this.params.package_id,
            // });
        },
        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if(valid) {
                    if(!this.releasePlan.length) {
                        this.isNotConfigVisible = true;
                        return;
                    }
                    this.operate_type = 'edit';
                    this.$emit('submit', this.params, 1)
                }
            })
        },
        configUrl() {
            let url = "/sdk/" + this.$routerMapsDefined.sdk.children.configEdit.url;
            url += `?game_code=${this.$activeGameCode}&platform=${this.$helper.helper.getParamers("platform").toLowerCase()}`;
            return url;
        }
    },
    created() {
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.selDisable = (this.operate_type === 'edit');
    }
}
</script>
<style lang="scss" scoped>
    .sdkconfigedit-formitem-width{
        width: 500px;
    }

    .allow-auto-process {
        margin: 40px;
        color: #f56c6c;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SearchDimension.vue